@if (links$ | async; as links) { @if (links.upselling?.products?.length || links.upselling?.categories?.length) {
<ish-product-links-carousel
  [links]="links.upselling"
  [productLinkTitle]="'product.product_links.upselling.title' | translate"
  [displayOnlyAvailableProducts]="true"
/>
} @if (links.spareparts?.products?.length || links.spareparts?.categories?.length) {
<ish-product-links-carousel
  [links]="links.spareparts"
  [productLinkTitle]="'product.product_links.spareparts.title' | translate"
/>
} @if (links.crossselling?.products?.length || links.crossselling?.categories?.length) {
<ish-product-links-carousel
  [links]="links.crossselling"
  [productLinkTitle]="'product.product_links.crossselling.title' | translate"
  [displayOnlyAvailableProducts]="true"
/>
} @if (links.accessory?.products?.length || links.accessory?.categories?.length) {
<ish-product-links-carousel
  [links]="links.accessory"
  [productLinkTitle]="'product.product_links.accessory.title' | translate"
/>
} @if (links.differentorderunit?.products?.length || links.differentorderunit?.categories?.length) {
<ish-product-links-carousel
  [links]="links.differentorderunit"
  [productLinkTitle]="'product.product_links.differentorderunit.title' | translate"
/>
} @if (links.followup?.products?.length || links.followup?.categories?.length) {
<ish-product-links-carousel
  [links]="links.followup"
  [productLinkTitle]="'product.product_links.followup.title' | translate"
/>
} @if (links.other?.products?.length || links.other?.categories?.length) {
<ish-product-links-carousel
  [links]="links.other"
  [productLinkTitle]="'product.product_links.other.title' | translate"
/>
} @if (links.replacement?.products?.length || links.replacement?.categories?.length) {
<ish-product-links-carousel
  [links]="links.replacement"
  [productLinkTitle]="'product.product_links.replacement.title' | translate"
/>
} @if (links.giftwrap?.products?.length || links.giftwrap?.categories?.length) {
<ish-product-links-carousel
  [links]="links.giftwrap"
  [productLinkTitle]="'product.product_links.giftwrap.title' | translate"
/>
} @if (links.giftmessage?.products?.length || links.giftmessage?.categories?.length) {
<ish-product-links-carousel
  [links]="links.giftmessage"
  [productLinkTitle]="'product.product_links.giftmessage.title' | translate"
/>
} @if (links.warranty?.products?.length || links.warranty?.categories?.length) {
<ish-product-links-carousel
  [links]="links.warranty"
  [productLinkTitle]="'product.product_links.warranty.title' | translate"
/>
} }
